import * as api from './api.js';
import * as multiuser from '../multiuser.js';

let _authChangeCallback = undefined;

function authChange() {
  if(_authChangeCallback)
    _authChangeCallback();
  multiuser.sendAuth();
}

export function onAuthChange(fn) {
  _authChangeCallback = fn;
}

export let _credStore = window.localStorage;

export function getUsername() {
  return _credStore.getItem('nota_username');
}
export function getUserId() {
  return _credStore.getItem('nota_id');
}
export function getToken() {
  return _credStore.getItem('nota_token');
}
export function isStaff() {
  return _credStore.getItem('nota_user_is_staff');
}
export function getCreds() {
  let creds = {};
  creds.token = _credStore.getItem('nota_token') || "";
  creds.username = _credStore.getItem('nota_username') || "b";
  creds.id = _credStore.getItem('nota_id') || "1";
  creds.is_staff = _credStore.getItem('nota_user_is_staff') || false;
  return creds;
}
export function setCreds(creds) {
  _credStore.setItem('nota_token', creds.token || "");
  _credStore.setItem('nota_username', creds.username || "");
  _credStore.setItem('nota_id', creds.id || "");
  _credStore.setItem('nota_user_is_staff', creds.is_staff || false);
}

export function loggedIn() {
  let creds = getCreds();
  return creds.token != '' &&
    creds.id != '1' &&
    creds.username !== 'AnonymousUser';
}
export function logout() {
  setCreds({
    token: '',
    username: 'AnonymousUser',
    id: 1
  });
  authChange();
}

export async function login(user, password) {
  console.log('log');
  try {
    const res = await api.post(
      'accounts/login/',
      {
        username: user,
        password: password
      }
    );
    if(res.res.ok) {
      let creds = await res.json;
      setCreds(creds);
    }
    authChange();
    return res;
  }
  catch(e) {
    throw e;
  }
}

export async function test() {
  let resp = await api.auth_post('accounts/test/', {});
  //msg.message(JSON.stringify(resp));
}

export async function change_password(current_password, new_password) {
  let response = await api.auth_post('accounts/change_password/', {
    current_password: current_password,
    new_password: new_password
  });
  return response;
}
